export const QUERY_STRING_PARAM = 'entitiesError';
export const ERROR_NAME_MUST_BE_UNIQUE =
    'Name must be unique within the same parent entity';
